import type { ReactElement } from 'react'

import { QuestionList } from './QuestionList'
import { QuestionItemList } from './questionLists'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

export const FaqPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="FAQ"
        subTitleText="よくあるご質問"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <main>
        {QuestionItemList.map(({ questionTitle, questionList }) => (
          <QuestionList
            key={questionTitle}
            questionTitle={questionTitle}
            questionList={questionList}
          />
        ))}
      </main>
    </Layout>
  )
}

FaqPage.getLayout = function getLayout(page: ReactElement) {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: 'よくあるご質問', path: '' },
  ]

  return (
    <>
      <Head
        title="よくあるご質問"
        description="トライアルホールディングスのIRに関するよくあるご質問を掲載しています。"
        ogp={{ url: 'ir/faq/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
